// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ad58ca6d","977":"3f0feade"}[chunkId] + ".chunk.js";
};